import * as React from 'react';
import { TestimonialsCommon } from './TestimonialsCommon';

export default function Testimonials() {
  return <TestimonialsCommon />;
}
